import React, { type ReactElement } from 'react'
import Tooltip from '@mui/material/Tooltip'
import { type TooltipProps } from '@mui/material'

import styles from './SimpleTooltip.module.scss'

export interface SimpleTooltipProps extends TooltipProps {
  title: string
  children: ReactElement<any, any>
  tooltipStyles?: string
}

const SimpleTooltip: React.FC<SimpleTooltipProps> = ({
  children,
  title,
  tooltipStyles,
  ...rest
}): ReactElement => {
  return (
    <Tooltip
      title={title}
      className={`${styles.container} ${tooltipStyles ?? ''}`}
      placement="right-start"
      followCursor
      classes={{
        tooltip: styles.tooltip,
      }}
      {...rest}
    >
      <div>{children}</div>
    </Tooltip>
  )
}

export default SimpleTooltip
